import styled, {css} from 'styled-components';

import {getColor, gts, ms} from '../../../../../../styles';
import {Button} from '../../../../../../uikit/Button';
import {Clickable} from '../../../../../../uikit/Clickable';
import {Text} from '../../../../../../uikit/Text';
import {View} from '../../../../../../uikit/View';

export const Message = styled(Text).attrs({variant: 'subtitle'})`
  text-align: center;
`;

export const MessageTitle = styled(Text).attrs({variant: 'h2', weight: 'bold'})`
  text-align: center;
  margin-bottom: ${gts('gap.sm')};
`;

export const Container = styled(View)`
  flex-direction: column;
  gap: ${gts('gap.xl')};
  align-items: center;
`;

export const WeightContainer = styled(View)`
  flex-direction: row;
  align-items: center;
  gap: ${gts('gap.xl')};
`;

export const WeightInputContainer = styled(View)`
  height: ${ms(61)};
`;

export const IconContainer = styled(View)`
  width: ${ms(60)};
  height: ${ms(61)};
  border: 1px solid ${getColor('border.light')};
  border-radius: ${gts('borderRadius.sm')};
  align-items: center;
  justify-content: center;
`;

export const OptionsContainer = styled(View)`
  gap: ${ms(12)};
`;

export const UnitOption = styled(Clickable)<{isSelected?: boolean}>`
  display: flex;
  height: ${ms(36)};
  width: ${ms(99)};
  border-radius: ${gts('borderRadius.sm')};
  background-color: ${getColor('background.grayLight')};
  justify-content: center;
  align-items: center;

  ${p =>
    p.isSelected &&
    css`
      background-color: ${getColor('static.accent.trackers')};
      color: ${getColor('text.white')};
    `}
`;

export const SubmitButton = styled(Button.V2).attrs({
  accentColor: 'static.accent.trackers',
  size: 'la',
})`
  width: 100%;
`;
